/**
 *  Builds a new instance of the Onboarder App after loading the StoryStream SDK.
 */

var App;
var ComponentList = [Accordion, AnimateNumber, Body, Carousel, Hero, Parallax, StoryStreamEmbed, TextMenu, YouTubeEmbed];
var ModuleList = [MetricAnalysisBlock];

//  StoryStream SDK has already loaded
if (typeof STRY !== 'undefined') {

    ExtendUtilities();

    App = new AppController(STRY, ComponentList, ModuleList);
}

//  Load StoryStream SDK (if it doesn't exists on the page)
else {

    var sdk = document.createElement('script');
    sdk.setAttribute('src', 'https://s3-eu-west-1.amazonaws.com/developers.storystream.it/sdk/js/app-min.js');
    document.body.appendChild(sdk);
    sdk.onload = function () {

        ExtendUtilities();

        App = new AppController(STRY, ComponentList, ModuleList);
    };
}
